import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import * as AuthActions from "../data/auth/AuthActions";

import LoginForm from '../components/LoginForm';

class LoginController extends React.Component
{
    state = {
        redirectNow: false
    };

    static propTypes = {
        login: PropTypes.func.isRequired,
        loggedIn: PropTypes.bool.isRequired
    };

    loginSubmit = (email, password, remember) => {
        return this.props.login(email, password, remember).then(() => {
            this.setState({redirectNow: true});
        });
    };

    render()
    {
        if (this.props.loggedIn || this.state.redirectNow) {
            return <Redirect to="/accounts" />;
        }

        return <div className="flex h-full items-center justify-center bg-indigo-800">
            <LoginForm onSubmit={this.loginSubmit} />
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    loggedIn: !! state.auth.id,
});

const mapDispatchToProps = {
    login: AuthActions.login,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginController)